function MajeUploader(elem) {
	this.buttonElem = $(elem);
	this.fileElem = $(this.buttonElem.attr('data-file'));
	this.progressElem = $(this.buttonElem.attr('data-progress'));
	if (this.progressElem.length == 0) {
		this.progressElem = this.buttonElem;
	}
	this.dropElem = $(this.buttonElem.attr('data-dropzone'))[0];
	this.type = this.buttonElem.attr('data-type');
	this.callFuncAfterUpload = this.buttonElem.attr('data-after-upload-function') || ""; //after upload will call like callFuncAfterUpload(outFilename, progressParent)
    this.callFuncWhenUploadStarts = this.buttonElem.attr('data-upload-started-function') || "";
	this.url = this.buttonElem.attr('data-url');
	this.fileNameElem = $(this.buttonElem.attr('data-filename'));
	this.readPreviewFileElem = $(this.buttonElem.attr('data-read-preview-to-elem'));
	this.callFuncAfterUploadF = $.noop;

	var maybeMulti = this.buttonElem.attr('data-multi');
	if (maybeMulti == undefined || maybeMulti == "false" ) {
		this.multi = false;
	} else {
		this.multi = true;
	}
	var maybeImage = this.buttonElem.attr('data-image');
	if (maybeImage == undefined || maybeImage == false) {
		this.image = null;
	} else {
		this.image = $(maybeImage);
	}

	this.attach();
}

MajeUploader.prototype.attach = function() {
	var self = this;
	var fe = this.fileElem[0];
	self.dropElem?.addEventListener("dragenter", function(e) {$(self.dropElem).trigger("draggingover"); e.stopPropagation(); e.preventDefault();} );
	self.dropElem?.addEventListener("dragover", function(e) { $(self.dropElem).trigger("draggingleft");  e.stopPropagation(); e.preventDefault();} );
	self.dropElem?.addEventListener("drop", function(e) { $(self.dropElem).trigger("dropped"); e.stopPropagation(); e.preventDefault(); self.handleFiles(e.dataTransfer.files); } );

	fe?.addEventListener('change', function() { self.handleFiles(self.fileElem[0].files); });
	self.buttonElem.on('click', function(e) { e.stopPropagation(); e.preventDefault(); self.fileElem[0].click(); });
};

MajeUploader.prototype.handleFiles = function(files) {
	var self = this;
	
	if (files.length < 1) {
		console.log("No Files: ", files);
		return;
	}
	if (files.length > 1 && !this.multi) {
		alert("Too many uploaded files, only handling the first one");
	}
	
	var thisFunc = function(fileList) {
		return function(data, textStatus, xhr) {
			for (var i = 0; i < fileList.length; i++) {
				self.startUpload(data, fileList[i]);
			}
		}
	}(files);

	//just for reading a readable file
	if (this.readPreviewFileElem.length) {
		previewElem = this.readPreviewFileElem;
		var reader = new FileReader();
		reader.addEventListener('load', function () {
			previewElem.val(reader.result)
			$(document).trigger("file_upload_complete");
		});
		reader.readAsText(files[0]);

		return
	}
	//upload this to a url
	if (this.url.length) {
		$.ajax({
			url: this.url,
			context: self,
			timeout: 5000,
			success: thisFunc
		});
	}
};

MajeUploader.prototype.startUpload = function(uploadData, file) {
	var self = this;

	var imageElem = null;
	var progressElem = null;
	var progressParent = null;

	var sizeFloat = file.size/(1024*102.4);
	var sizeMegs = Math.round(sizeFloat/10)+"."+Math.round(sizeFloat%10);
	
	if (self.multi) {
		var progressNode = self.progressElem.clone();
		
		progressNode.attr("id", self.progressElem[0].id+Math.floor(Math.random()*100000));
		progressNode[0].style.display = "";
	
		progressNode.appendTo(self.progressElem.parent());
		var selfElem = $(progressNode);
		progressParent = selfElem;
		selfElem.find('.filename').text(file.name);
		selfElem.find('.size').text(sizeMegs + " MB");
		if (self.image != null) {
			imageElem = selfElem.find('.image');
		}
		selfElem.find('.progress').css('display', '');
		if (selfElem.hasClass('progress-bar')) {
			progressElem = selfElem;
		} else {
			progressElem = selfElem.find('.progress-bar');
		}
	} else {
		progressElem = self.progressElem;
		progressParent = self;
		imageElem = self.image;
	}

	if (imageElem != null) {
		var reader = new FileReader();
		reader.addEventListener('load', function() { imageElem[0].src = reader.result; });
		reader.readAsDataURL(file);
	}
	
	var outFilename = uploadData.key.replace("${filename}", file.name);

	if (progressElem.parent().css('display') == 'none') {
		progressElem.parent().css('display', 'inline-block');
	}
	
	progressElem.css("display", "block");
	progressElem.css("width", "0%");
	progressElem.text('0%');

	var xhr = new XMLHttpRequest();
	var fd = new FormData();

	fd.append("GoogleAccessId", uploadData.google_access_id);
	fd.append("bucket", uploadData.bucket);
	fd.append("key", uploadData.key);
	fd.append("acl", uploadData.acl);
	fd.append("policy", uploadData.policy);
	fd.append("signature", uploadData.signature);
	fd.append("Content-Type", file.type);

    if (self.callFuncWhenUploadStarts.length) {
        window[self.callFuncWhenUploadStarts](file.name)
    }
	
	xhr.open("POST", uploadData.upload_url, true);
	xhr.upload.addEventListener('progress', function(e) {
		if (e.lengthComputable) {
			var percentage = Math.round((e.loaded * 100) / e.total);
			progressElem.text(""+percentage+"%");
			progressElem.css("width", ""+percentage+"%");
		}
	}, false);
	xhr.upload.addEventListener("load", function(e){
		progressElem.css("width", "100%");
		progressElem.text("100%");

		if (self.multi) {
			var formNode = self.fileNameElem[0].cloneNode(true);
			formNode.value = outFilename;
			self.fileNameElem[0].parentNode.appendChild(formNode);
		} else {
			self.fileNameElem.val(outFilename);
		}
		$( document ).trigger("file_upload_complete", [ outFilename, progressParent] );
		if (self.callFuncAfterUpload.length) {
			window[self.callFuncAfterUpload](outFilename, progressParent)
		}
		self.callFuncAfterUploadF(outFilename, progressParent);
    }, false);
	xhr.upload.addEventListener("onerror", function(e) {
		progressElem.css("width", "100%");
		progressElem.text("ERROR");
		alertify.alert("Upload failed!");
	}, false);

	fd.append('file', file);
	xhr.send(fd);
};


$(document).ready(function() {
	$('.maje_upload').each(function() {
		new MajeUploader(this);
	});
});
